<template>
    <nav>
        <AlertMessages
            v-if="alertValue"
            :alert-type="alertType"
            :alert-msg="alertMsg"
            @reset="alertValue = false"
        />
        <v-row
            class="fill-height"
            align="center"
        >
            <v-col
                cols="12"
                md="8"
                offset-md="2"
                align="center"
            >
                <v-card
                    max-width="960"
                    elevation="6"
                    rounded="xxl"
                    color="background"
                    :class="mobile() ? 'pa-16':'card-padding'"
                >
                    <div class="text-h4 font-weight-bold text-center no-break mb-8" v-html='$t("acceptGDPRTitle")'>
                    </div>
                    <div class="text-h6 font-weight-regular text-left no-break mb-4" v-html='$t("acceptGDPRText1")'>
                    </div>
                    <div class="text-h6 font-weight-regular text-left no-break mb-8" v-html="$t('acceptGDPRText2', {
                      'terms-of-services': `<a target='_blank' href='/terms-of-service'>${ $t('termsOfServices') }</a>`,
                      'privacy-policy': `<a target='_blank' href='/privacy-policy'>${ $t('privacyPolicy') }</a>`
                    })" >
                    </div>
                    <div class="checkbox-align-start">
                        <v-checkbox
                            data-testid="gdpr-input"
                            color="accent"
                            class="text-left"
                            @change="gdpr($event)"
                        >
                            <template v-slot:label>
                                <!-- eslint-disable vue/no-v-html -->
                                <div class="text-h6 font-weight-regular text-center no-break" v-html='$t("acceptGDPRText3")'>
                                </div>
                            </template>
                        </v-checkbox>
                    </div>
                    <v-card-actions class="px-0">
                        <v-btn
                            data-testid="submit-button"
                            type="submit"
                            :disabled="buttonDisabled"
                            color="accent"
                            large
                            block
                            class="rounded-xxl text-none"
                            @click="acceptGDPR"
                            >
                            {{ $t('next') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </nav>
</template>
<script>
import i18n from '../../plugins/i18n'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import { redirectUserAfterSocialLoginAcceptGDPR } from '../../api/userApi'
import { loginAuth } from '../../auth/auth.js'
import AlertMessages  from '../../components/AlertMessages'

export default {
    components: {
        AlertMessages
    },
    mixins: [repeatedMethodsMixin],
    data(){
        return{
            buttonDisabled: true,
            loginToken: null,
            alertValue: false
         }
    },
    created() {
        if(this.$route.params.loginToken){     
          this.loginToken = this.$route.params.loginToken
        }
        i18n.locale = window.$cookies.get('language') ? window.$cookies.get('language') : 'en'
    },
    methods: {
        gdpr: function(e) {
            this.buttonDisabled = e === true ? false : true
        },
        async acceptGDPR(){
            try{
                let data = null;
                data = {
                    data: {
                        type: "users", 
                        attributes: {
                            accepted_gdpr: true
                        }
                    }
                }

                const response = await redirectUserAfterSocialLoginAcceptGDPR(data, this.loginToken)
                if(response.status == 200) {
                    //redirect to the new space
                    loginAuth(response.data.meta.access_token, response.data.data)

                    if (window.$cookies.isKey("google_referer")) {
                        window.location.href = window.$cookies.get("google_referer").redirect
                        window.$cookies.remove("google_referer")
                        window.$cookies.remove("google_referer", null, process.env.VUE_APP_DOMAIN);
                    }else{
                        this.$router.push('/spaces')
                    }
                    
                }
            }catch(e){
                if(e.response){
                    this.alertValue = true
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError')
                }
            }
        }
    }
}
</script>
